import { useEffect } from "react";
import { useFormik } from "formik";
import { SketchTextAnnotationEditor, TextAnnotation } from "ui-components";

import {
	useSetActive,
	useSelectSketch,
	useSelectFeatureId,
	useSketchGeojson,
	useIsNewSketch,
	useDeleteFeature,
	useUpdateSketchGeojson,
} from "~map-view/states/sketch";
interface Props {
	active: string;
}
export const TextAnnotationEditor = ({ active }: Props) => {
	const updateSketchGeojson = useUpdateSketchGeojson();
	const deleteFeature = useDeleteFeature();
	const setActive = useSetActive();
	const sketchGeojson = useSketchGeojson();
	const selectFeatureId = useSelectFeatureId();
	const isNewSketch = useIsNewSketch();
	const selectSketch = useSelectSketch();
	const form = useFormik<TextAnnotation>({
		initialValues: {
			text: "Content here",
		},
		onSubmit: (values, helpers) => {
			if (!selectFeatureId || !sketchGeojson) return;
			updateSketchGeojson(values, "annotation");

			if (isNewSketch(selectSketch?.id ?? "")) setActive("Create Sketch");
			else setActive("edit-sketch");

			helpers.resetForm();
		},
	});

	useEffect(() => {
		if (selectFeatureId && sketchGeojson && active === "text-annotation") {
			updateSketchGeojson(form.values, "annotation");
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectFeatureId, active]);

	const handleDelete = () => {
		deleteFeature(selectFeatureId);
		if (isNewSketch(selectSketch?.id ?? "")) setActive("Create Sketch");
		else setActive("edit-sketch");
	};

	if (active === "text-annotation") {
		return (
			<SketchTextAnnotationEditor
				form={form}
				onDelete={handleDelete}
			/>
		);
	} else return null;
};
